import React, { useCallback, useEffect, useState } from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllServices } from '../../../../store/common/servicesSlice';
import { Col, Row, Collapse, Checkbox, Button, Modal, Input } from 'antd';
import { FaCheck } from "react-icons/fa";
import DynamicForm from '../../../../components/FormElements/DynamicForm';
import CustomTextArea from './customTextArea';
import CustomBenefits from './customBenefits';
import CustomDayPicker from './customDayPicker';
import { ApiCaller, Colors } from '../../../../config';
import { Controller, useForm } from 'react-hook-form';
import { Label } from 'recharts';
import TextArea from 'antd/es/input/TextArea';
import { FaMapMarkerAlt } from "react-icons/fa";
import LocationPicker from '../../../../components/LocationPicker';
import { yupResolver } from '@hookform/resolvers/yup';
import { businessInfoSchema } from './schema';
import { setError, setMessage } from '../../../../store/common/generalSlice';
import { useMutation } from 'react-query';
import '../style.css'
import { useNavigate } from 'react-router-dom';

const BusinessInfo = () => {

    const dispatch = useDispatch();

    const schema = businessInfoSchema;
    const { control, handleSubmit, reset, formState: { isDirty } } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange'
    })

    const { loading: servicesLoading, services } = useSelector(state => state?.services);
    const { profileData } = useSelector(state => state?.setting);

    const [allServices, setAllServices] = useState([]);
    const [selectedServices, setSelectedServices] = useState({})
    const [selectedFinalServices, setSelectedFinalServices] = useState({})
    const [defaultActiveCollapseKeys, setDefaultActiveCollapseKeys] = useState(null)
    const [extraDetailModal, setExtraDetailModal] = useState({
        show: false,
        data: {},
        error: {
            checkboxError: "",
            priceError: ""
        }
    });
    const [currentActiveCollapseKey, setCurrentActiveCollapseKey] = useState('')

    // to get the coordinates from the location component as the onChange is only setting the
    // formatted address for the field
    const [coordinates, setCoordinates] = useState({
        businessLatitude: '',
        businessLongitude: ''
    })

    // a state to reset some of the custom field after submission of a form
    const [customFieldReset, setCustomFieldReset] = useState({
        address: false,
        time: false
    })

    // a state to hold the timePickers array after onChange as directly using onChange of a form
    // clearing the entire array of working days.
    const [timePickers, setTimePickers] = useState([]);

    // need only in case of edit
    const [isDisabled, setIsDisabled] = useState({
        isWorkingDaysDirty: false,
        isServicesDirty: false
    })

    // custom error handling 
    const [customError, setCustomError] = useState({
        time: '',
        services: ''
    })

    const navigate = useNavigate();


    useEffect(() => {
        if (services) {
            let listedServices = services?.map((service) => {
                return (
                    {
                        name: service?.name,
                        firstParentId: service?.id,
                        subServices: service?.subServices?.length > 0 ?
                            service?.subServices?.map((subService) => {
                                return (
                                    {
                                        name: subService?.name,
                                        secondParentId: subService?.id,
                                        subServices: subService?.subServices?.length > 0 ?
                                            subService?.subServices?.map((service) => {
                                                return (
                                                    {
                                                        id: service?.id,
                                                        name: service?.name
                                                    }
                                                )
                                            })
                                            : []
                                    }
                                )
                            })
                            : []
                    }
                )
            })


            let tempObjectOfFirstParent = {};
            let tempObjectOfSecondParent = {};
            let defaultActiveKeyIds = []

            for (const element of services) {
                tempObjectOfFirstParent[element?.id] = [];
                tempObjectOfSecondParent[element?.id] = [];
            }

            if (profileData && profileData?.userServices?.length > 0) {
                let tempFirstParentKeys = Object.keys(tempObjectOfFirstParent);

                profileData?.userServices.map((item) => {
                    // case 1 if parentId is null that means the object item belongs to the first layer.
                    if (item?.service?.parentId == null) {
                        let defaultKey = defaultActiveKeyIds?.find((defaultKey) => defaultKey == item?.service?.id);
                        if (!defaultKey) {
                            defaultActiveKeyIds.push(item?.service?.id)
                        }

                        let isParentExist = tempObjectOfSecondParent[item?.service?.id]?.filter((subItem) => {
                            return subItem?.serviceId == item?.service?.id
                        });

                        // if (isParentExist?.length > 0) {
                        //     tempObjectOfSecondParent[item?.service?.id] = [...tempObjectOfSecondParent[item?.service?.id]]
                        // }

                        if (isParentExist?.length == 0) {
                            tempObjectOfSecondParent[item?.service?.id] =
                                [...tempObjectOfSecondParent[item?.service?.id], { serviceId: Number(item?.service?.id), details: item?.userServicePrice ? item?.userServicePrice : null }]
                        }

                    }
                    if (item?.userServicePrice !== null) {
                        let extraDetailModalCloneData = { ...extraDetailModal.data };
                        if (item?.service?.id && !extraDetailModalCloneData[item?.service?.id]) {
                            setExtraDetailModal((prev) =>
                            ({
                                ...prev, data: {
                                    ...prev?.data,
                                    [item?.service?.id]: {
                                        cars: item?.userServicePrice?.cars,
                                        vans: item?.userServicePrice?.vans,
                                        price: item?.userServicePrice?.price
                                    }
                                }
                            }))
                        }
                    }
                    if (item?.service?.parentId !== null) {

                        let key = tempFirstParentKeys?.find((keyItem) => keyItem == item?.service?.parentId);
                        let childKey = item?.service?.id;

                        if (!key) {
                            // if !key that means the parentId is actually an id of secondLayer parent.
                            let listing = [];
                            outerLoop:
                            for (let service of listedServices) {
                                if (service?.subServices?.length > 0) {
                                    for (let subItem of service.subServices) {
                                        if (subItem?.secondParentId == item?.service?.parentId) {
                                            listing.push(service);
                                            break outerLoop;
                                        }
                                    }
                                }
                            }

                            if (listing?.length > 0) {
                                let tempObj = listing[0];
                                let firstParentId = tempObj?.firstParentId;
                                let isParentExist = tempObjectOfSecondParent[firstParentId]?.filter((subItem) => {
                                    return subItem?.serviceId == item?.service?.parentId
                                });

                                let isChildExist = tempObjectOfFirstParent[firstParentId]?.filter((subItem) => {
                                    return subItem == item?.service?.id
                                });

                                // if (isParentExist?.length > 0) {
                                //     tempObjectOfSecondParent[firstParentId] = [...tempObjectOfSecondParent[firstParentId]]
                                // }

                                if (isParentExist?.length == 0) {
                                    tempObjectOfSecondParent[firstParentId] =
                                        [...tempObjectOfSecondParent[firstParentId], { serviceId: Number(item?.service?.parentId), details: item?.userServicePrice ? item?.userServicePrice : null }]
                                }

                                // if (isChildExist?.length > 0) {
                                //     tempObjectOfFirstParent[firstParentId] = [...tempObjectOfFirstParent[firstParentId]];
                                // }

                                if (isChildExist?.length == 0) {
                                    tempObjectOfFirstParent[firstParentId] =
                                        [...tempObjectOfFirstParent[firstParentId], item?.service?.id]
                                }
                            }
                        }

                        else {
                            let defaultKey = defaultActiveKeyIds?.find((defaultKey) => defaultKey == key);
                            if (!defaultKey) {
                                defaultActiveKeyIds.push(key)
                            }

                            let isParentExist = tempObjectOfSecondParent[key]?.filter((item) => {
                                return item?.serviceId == key
                            });

                            let isChildExist = tempObjectOfSecondParent[key]?.filter((item) => {
                                return item?.serviceId == childKey
                            });

                            // if (isParentExist?.length > 0) {
                            //     tempObjectOfSecondParent[key] = [...tempObjectOfSecondParent[key]]
                            // }

                            if (isParentExist?.length == 0) {
                                tempObjectOfSecondParent[key] =
                                    [...tempObjectOfSecondParent[key], { serviceId: Number(key), details: item?.userServicePrice ? item?.userServicePrice : null }]
                            }

                            // if (isChildExist?.length > 0) {
                            //     tempObjectOfSecondParent[key] = [...tempObjectOfSecondParent[key]];
                            // }

                            if (isChildExist?.length == 0) {
                                tempObjectOfSecondParent[key] =
                                    [...tempObjectOfSecondParent[key], { serviceId: Number(childKey), details: item?.userServicePrice ? item?.userServicePrice : null }]
                            }
                        }
                    }
                })

                setDefaultActiveCollapseKeys(defaultActiveKeyIds)
            }

            setSelectedServices(tempObjectOfFirstParent)
            setAllServices(listedServices)
            setSelectedFinalServices(tempObjectOfSecondParent)
        }
    }, [services])

    // pre filled the form data in case of edit
    useEffect(() => {
        if (profileData && profileData?.userServices?.length > 0) {
            reset({
                businessName: profileData?.userDetail?.businessName ? profileData?.userDetail?.businessName : '',
                website: profileData?.userDetail?.website ? profileData?.userDetail?.website : '',
                businessContact: profileData?.userDetail?.businessContact ? profileData?.userDetail?.businessContact : '',
                aboutBusiness: profileData?.userDetail?.aboutBusiness ? profileData?.userDetail?.aboutBusiness : '',
                businessLocation: profileData?.userDetail?.businessLocation ? profileData?.userDetail?.businessLocation : '',
                benefits: profileData?.userDetail?.benefits ? JSON.parse(profileData?.userDetail?.benefits) : [],
                workingDays: profileData?.workingDays ? profileData?.workingDays : []
            })
            setCoordinates({
                businessLatitude: Number(profileData?.userDetail?.latitude),
                businessLongitude: Number(profileData?.userDetail?.longitude)
            })
            if (profileData?.workingDays) {
                console.log(profileData?.workingDays)
                setTimePickers(() => profileData?.workingDays?.map((timePicker) => {
                    return {
                        ...timePicker,
                        dayChecked: true
                    }
                }))
            }
        }


    }, [profileData])

    console.log("timePickers", timePickers)

    console.log("timePickers", timePickers)

    const collapseHandler = (activeKey) => {
        let previousActiveKeys = defaultActiveCollapseKeys;
        if (typeof activeKey == 'object') {
            if (previousActiveKeys?.length < activeKey?.length) {
                let lastElement = activeKey[activeKey.length - 1];
                let extraDetails = services.find(item => item?.id == lastElement);
                if (extraDetails?.isDetailsRequired && activeKey) {
                    let extraDetailModalCloneData = { ...extraDetailModal.data };
                    if (!extraDetailModalCloneData.hasOwnProperty(lastElement)) {
                        setCurrentActiveCollapseKey(lastElement);
                        setExtraDetailModal((prev) => ({
                            ...prev, show: true, data: {
                                ...prev.data, [lastElement]: {
                                    cars: false,
                                    vans: false,
                                    price: ""
                                }
                            }
                        }))
                    }
                    else {
                        setCurrentActiveCollapseKey(lastElement);
                        setExtraDetailModal((prev) => ({ ...prev, show: true }))
                    }
                } else {
                    setExtraDetailModal((prev) => ({ ...prev, show: false }))
                }
            } else {
                setExtraDetailModal((prev) => ({ ...prev, show: false }))
            }
        }
        else {
            let extraDetails = services.find(item => item?.id == activeKey);
            if (extraDetails?.isDetailsRequired && activeKey) {
                let extraDetailModalCloneData = { ...extraDetailModal.data };
                if (!extraDetailModalCloneData.hasOwnProperty(activeKey)) {
                    setCurrentActiveCollapseKey(activeKey);
                    setExtraDetailModal((prev) => ({
                        ...prev, show: true, data: {
                            ...prev.data, [activeKey]: {
                                cars: false,
                                vans: false,
                                price: ""
                            }
                        }
                    }))
                }
                else {
                    setCurrentActiveCollapseKey(activeKey);
                    setExtraDetailModal((prev) => ({ ...prev, show: true }))
                }
            } else {
                setExtraDetailModal((prev) => ({ ...prev, show: false }))
            }
        }

        if (activeKey) {
            setDefaultActiveCollapseKeys(activeKey)
        }
    }

    const checkboxHandler = (e) => { }


    const handleCheckAll = (firstParentId, subService, checked) => {
        console.log(subService);
        // a case for edit only
        if (profileData?.userServices?.length > 0 && !isDisabled.isServicesDirty) {
            setIsDisabled({ ...isDisabled, isServicesDirty: true })
        }
        // Update selected services
        setSelectedServices((prev) => {
            const currentSelected = prev[firstParentId] || [];
            const subServiceIds = subService?.subServices?.map(s => s.id) || [];

            // Update selected services based on whether checked or not
            const updatedSelected = checked
                ? [...new Set([...currentSelected, ...subServiceIds])]
                : currentSelected.filter(id => !subServiceIds.includes(id));

            return {
                ...prev,
                [firstParentId]: updatedSelected,
            };
        });

        // Update selected final services
        setSelectedFinalServices((prevFinalServices) => {
            const updatedFinalServices = { ...prevFinalServices };
            const service = updatedFinalServices[firstParentId] || [];

            // Ensure firstParentId exists
            if (!service.some(item => item?.serviceId === firstParentId)) {
                updatedFinalServices[firstParentId] = [
                    ...service,
                    { serviceId: firstParentId, details: null }
                ];
            }

            // Handle second layer of parent (if it exists)
            const secondParentId = subService?.secondParentId; // Directly access secondParentId

            if (secondParentId) {
                // Update second parent services based on check
                if (checked) {
                    // Add the second parent if checked
                    if (!service.some(item => item?.serviceId === secondParentId)) {
                        updatedFinalServices[firstParentId].push({
                            serviceId: secondParentId,
                            details: null
                        });
                    }
                } else {
                    // If unchecked, remove the second parent
                    updatedFinalServices[firstParentId] = updatedFinalServices[firstParentId].filter(
                        item => item.serviceId !== secondParentId
                    );
                }
            }

            // Check if the firstParentId needs to be updated
            if (!checked) {
                // Check if there are any remaining secondParentIds associated with firstParentId
                const hasRemainingSecondParents = updatedFinalServices[firstParentId].some(item => item.serviceId !== firstParentId);
                if (!hasRemainingSecondParents) {
                    // If no secondParentIds are left, set firstParentId to an empty array instead of deleting it
                    updatedFinalServices[firstParentId] = [];
                }
            }

            return updatedFinalServices;
        });
    };


    //     const { name, firstParentId } = service;

    //     // Update selectedServices for individual sub-service check
    //     setSelectedServices((prev) => {
    //         const currentSelected = prev[firstParentId] || [];
    //         const updatedSelected = checked
    //             ? [...new Set([...currentSelected, thirdLayerSubService.id])]
    //             : currentSelected.filter(id => id !== thirdLayerSubService.id);

    //         return {
    //             ...prev,
    //             [firstParentId]: updatedSelected,
    //         };
    //     });

    //     // Update selectedFinalServices for both firstParentId and secondParentId
    //     setSelectedFinalServices((prevFinalServices) => {
    //         let updatedFinalServices = { ...prevFinalServices };
    //         let firstService = prevFinalServices[firstParentId] || [];

    //         // Handle first layer of parent (firstParentId)
    //         let testFirstParent = firstService.find(item => item?.serviceId === firstParentId);
    //         if (!testFirstParent) {
    //             firstService = [
    //                 ...firstService,
    //                 { serviceId: firstParentId, details: null }
    //             ];
    //         } else {
    //             let indexFirstParent = firstService.findIndex(s => s.serviceId === testFirstParent.serviceId);
    //             firstService[indexFirstParent] = {
    //                 serviceId: firstParentId,
    //                 details: null
    //             };
    //         }

    //         updatedFinalServices[firstParentId] = firstService;

    //         // Handle second layer of parent (secondParentId)
    //         let secondParentId = subService?.secondParentId;
    //         if (secondParentId) {
    //             let secondService = updatedFinalServices[firstParentId] || [];
    //             let testSecondParent = secondService.find(item => item?.serviceId === secondParentId);
    //             if (!testSecondParent) {
    //                 secondService = [
    //                     ...secondService,
    //                     { serviceId: secondParentId, details: null }
    //                 ];
    //             } else {
    //                 let indexSecondParent = secondService.findIndex(s => s.serviceId === secondParentId);
    //                 secondService[indexSecondParent] = {
    //                     serviceId: secondParentId,
    //                     details: null
    //                 };
    //             }

    //             updatedFinalServices[firstParentId] = secondService;
    //         }

    //         return updatedFinalServices;
    //     });
    // };

    const handleSubServiceCheck = (service, thirdLayerSubService, subService, checked) => {
        const { name, firstParentId } = service;
        const secondParentId = subService?.secondParentId;

        // a case for edit only
        if (profileData?.userServices?.length > 0 && !isDisabled.isServicesDirty) {
            setIsDisabled({ ...isDisabled, isServicesDirty: true })
        }

        // Update selectedServices for individual sub-service check
        setSelectedServices((prev) => {
            const currentSelected = prev[firstParentId] || [];
            const updatedSelected = checked
                ? [...new Set([...currentSelected, thirdLayerSubService.id])]
                : currentSelected.filter(id => id !== thirdLayerSubService.id);

            return {
                ...prev,
                [firstParentId]: updatedSelected,
            };
        });

        // Update selectedFinalServices for both firstParentId and secondParentId
        setSelectedFinalServices((prevFinalServices) => {
            let updatedFinalServices = { ...prevFinalServices };

            // Ensure firstParentId exists in updatedFinalServices
            if (!updatedFinalServices[firstParentId]) {
                updatedFinalServices[firstParentId] = [];
            }

            // Handle second layer (secondParentId)
            if (secondParentId) {
                let firstService = updatedFinalServices[firstParentId];

                // Add both firstParentId and secondParentId when checked
                if (checked) {
                    const firstParentExists = firstService.some(item => item?.serviceId === firstParentId);
                    if (!firstParentExists) {
                        firstService.push({ serviceId: firstParentId, details: null });
                    }

                    const secondParentExists = firstService.some(item => item?.serviceId === secondParentId);
                    if (!secondParentExists) {
                        firstService.push({ serviceId: secondParentId, details: null });
                    }
                } else {
                    // On uncheck, check for remaining third-layer IDs
                    const remainingThirdLayerIds = selectedServices[firstParentId]?.filter(id => id !== thirdLayerSubService.id);

                    // Update the selectedServices state
                    setSelectedServices((prev) => ({
                        ...prev,
                        [firstParentId]: remainingThirdLayerIds,
                    }));

                    // Check if there are any remaining third-layer IDs associated with the secondParentId
                    const secondLayerSubServices = allServices.find(s => s.firstParentId === firstParentId)?.subServices || [];
                    const hasRemainingThirdLayerForSecondParent = secondLayerSubServices
                        .find(sub => sub.secondParentId === secondParentId)?.subServices
                        .some(thirdSub => remainingThirdLayerIds.includes(thirdSub.id));

                    // If no remaining third-layer IDs for the secondParentId, remove it from finalServices
                    if (!hasRemainingThirdLayerForSecondParent) {
                        updatedFinalServices[firstParentId] = updatedFinalServices[firstParentId].filter(
                            item => item.serviceId !== secondParentId
                        );
                    }

                    // Now check if we need to clear the array for the firstParentId
                    const hasRemainingThirdLayersForFirstParent = remainingThirdLayerIds.length > 0;

                    // If no remaining third-layer IDs exist for firstParentId, empty its array instead of removing the property
                    if (!hasRemainingThirdLayersForFirstParent) {
                        updatedFinalServices[firstParentId] = [];
                    } else if (updatedFinalServices[firstParentId]?.length === 0) {
                        updatedFinalServices[firstParentId] = [];
                    }
                }
            }

            return updatedFinalServices;
        });
    };

    // a function to render subServices in a children property of Collapse component.
    const renderSubServices = (service) => {
        return service?.subServices?.map((subService, index) => {
            return (
                <div className='mb-4 mr-6' key={index}>
                    <Row className='mb-2' justify={'space-between'} key={index}>
                        <Col>{subService?.name}</Col>
                        <Col className='flex items-center gap-3'>
                            <Checkbox
                                indeterminate={
                                    selectedServices[service?.firstParentId]?.length > 0 &&
                                    selectedServices[service?.firstParentId]?.length < subService?.subServices?.length &&
                                    subService?.subServices?.some(sub => selectedServices[service?.firstParentId]?.includes(sub.id))
                                }
                                disabled={subService?.subServices?.length == 0 ? true : false}
                                checked={
                                    subService?.subServices?.length !== 0 &&
                                    subService?.subServices?.every(sub => selectedServices[service?.firstParentId]?.includes(sub.id))
                                }
                                onChange={(e) => handleCheckAll(service?.firstParentId, subService, e.target.checked)}
                            >
                                Select All
                            </Checkbox>
                        </Col>
                    </Row>

                    <div className={`bg-[#f1f6fa] rounded-md p-2 w-full`}>
                        <Checkbox.Group className='w-full' value={selectedServices[service?.firstParentId]}>
                            <Row justify={'space-between'}>
                                {
                                    subService?.subServices?.length > 0 ?
                                        subService?.subServices?.map((thirdLayerSubService, index) => {
                                            return (
                                                <Col lg={8} className='flex gap-3 items-center mb-3' key={index}>
                                                    <Checkbox
                                                        value={thirdLayerSubService?.id}
                                                        onChange={(e) =>
                                                            handleSubServiceCheck(service, thirdLayerSubService, subService, e.target.checked)}
                                                    >
                                                        {thirdLayerSubService?.name}
                                                    </Checkbox>
                                                </Col>
                                            )
                                        })
                                        :
                                        <p className='text-gray-400 text-sm'>No sub service available</p>
                                }
                            </Row>
                        </Checkbox.Group>
                    </div>
                </div>
            )
        })
    }

    // items to render in collapse
    const items = allServices?.map((service, index) => {
        return (
            {
                key: service?.firstParentId,
                label: service?.name,
                children: (
                    <div key={index} className='h-28 overflow-y-auto'>
                        {renderSubServices(service)}
                    </div>
                ),
            }
        )
    })

    // function to check if my services object with array contain even a single value or not.
    const hasNonEmptyArray = (obj) => {
        return Object.values(obj).some(arr => arr.length > 0);
    };

    const businessInfoMutation = useMutation(async (data) => {
        console.log("mutation", data)
        console.log("mutation", data)
        let res = await ApiCaller.put('/user/business-profile', data);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                reset({
                    businessName: '',
                    website: '',
                    businessContact: '',
                    aboutBusiness: '',
                    businessLocation: '',
                    benefits: [],
                    workingDays: []
                })

                setCustomFieldReset({ ...customFieldReset, address: true, time: true })
                setDefaultActiveCollapseKeys(null)
                setSelectedFinalServices({})
                setSelectedServices({})
                setCustomError({ time: '', services: '' })
                setTimePickers([])
                navigate('/settings')
            },

            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    const submitForm = (data) => {

        let cloneSelectedServices = { ...selectedServices };
        let cloneSelectedFinalServices = { ...selectedFinalServices };
        let cloneTimePicker = [...timePickers];

        let validCases;

        if (cloneTimePicker?.length == 0) {
            setCustomError({ ...customError, time: 'Time is required' });
            return
        }

        if (cloneTimePicker) {
            // Check if there is at least one valid object with the required conditions
            const hasValidCondition = cloneTimePicker.some((subItem) => {
                return subItem?.dayChecked && (
                    subItem?.startTime !== null ||
                    subItem?.time !== null ||
                    subItem?.closed === true
                );
            });

            // Check if there is an object where dayChecked is true but time is null and closed is false (invalid case)
            const hasInvalidDayChecked = cloneTimePicker.some((subItem) => {
                return subItem?.dayChecked && subItem?.time === null && !subItem?.closed;
            });

            // Check if there is an object where dayChecked is false but time exists (invalid case)
            const hasTimeButNoDayChecked = cloneTimePicker.some((subItem) => {
                return !subItem?.dayChecked && subItem?.time !== null;
            });

            // If any invalid case is found or if no valid condition exists, show the error
            if (!hasValidCondition || hasInvalidDayChecked || hasTimeButNoDayChecked) {
                setCustomError({ ...customError, time: 'Time and day check is required' });
                return;
            }

            // If all checks pass, filter and return valid cases
            validCases = cloneTimePicker.filter((subItem) => {
                return subItem?.dayChecked && (
                    subItem?.startTime !== null ||
                    subItem?.time !== null ||
                    subItem?.closed === true
                );
            });
        }

        if (!hasNonEmptyArray(cloneSelectedServices)) {
            dispatch(setError('Service is required'))
            setCustomError({ ...customError, time: '' });
            return
        }
        else {
            // Log or handle updatedWorkingDays
            let workingDays = validCases
                .map(item => {
                    let startTime, endTime;
                    // Check if time is an array
                    if (Array.isArray(item?.time)) {
                        startTime = item?.closed ? null : (item?.time[0] || null);
                        endTime = item?.closed ? null : (item?.time[1] || null);
                    } else {
                        // If not an array, use separate startTime and endTime keys
                        startTime = item?.closed ? null : item?.startTime;
                        endTime = item?.closed ? null : item?.endTime;
                    }
                    return {
                        day: item?.day,
                        startTime,
                        endTime,
                        closed: item?.closed
                    };
                })
                .filter(item => !(item?.startTime === null && item?.endTime === null && !item?.closed)); // Remove items with null times unless closed is true

            // Log or handle updatedWorkingDays
            let updatedWorkingDays = workingDays
                .filter(item => !(item?.startTime == null && item?.endTime == null && !item?.closed)) // Remove items with null times unless closed is true
                .map(item => {
                    if (item?.closed && item?.day) {
                        // If the item is closed, return an object with only 'day' and 'closed'
                        return {
                            day: item?.day,
                            closed: item?.closed
                        };
                    }
                    return item; // Otherwise, return the item as is
                });

            let services = [];
            for (const key in cloneSelectedFinalServices) {
                cloneSelectedFinalServices[key].forEach(item => {
                    services.push({
                        serviceId: item.serviceId,
                        details: item.details || null
                    });
                });
                cloneSelectedServices[key].forEach(serviceId => {
                    if (!cloneSelectedFinalServices[key].find(item => item.serviceId === serviceId)) {
                        services.push({
                            serviceId: serviceId,
                            details: null
                        });
                    }
                });
            }

            let payload = {
                ...data,
                workingDays: updatedWorkingDays,
                services,
                businessLatitude: coordinates?.businessLatitude,
                businessLongitude: coordinates?.businessLongitude,
                businessAddressLine1: "",
                businessAddressLine2: "",
                businessTown: "",
                businessPostalCode: ""
            }

            businessInfoMutation.mutate(payload)
        }

    }

    const motSubmitHandler = () => {
        if ((!extraDetailModal?.data?.[currentActiveCollapseKey]?.cars && !extraDetailModal?.data?.[currentActiveCollapseKey]?.vans)) {
            setExtraDetailModal((prev) => ({ ...prev, error: { ...prev.error, checkboxError: 'Type is required' } }))
        }
        else if (!extraDetailModal?.data?.[currentActiveCollapseKey]?.price) {
            setExtraDetailModal((prev) => ({ ...prev, error: { ...prev.error, priceError: 'Price is required' } }))
        }
        else {
            let selectedFinalServicesClone = { ...selectedFinalServices };
            let extraDetailModalData = extraDetailModal?.data[currentActiveCollapseKey];
            if (currentActiveCollapseKey && selectedFinalServicesClone.hasOwnProperty(currentActiveCollapseKey)) {
                let selectedService = selectedFinalServicesClone[currentActiveCollapseKey];
                selectedFinalServicesClone[currentActiveCollapseKey] = selectedService.map((subItem) => {
                    if (subItem?.serviceId == currentActiveCollapseKey) {
                        return {
                            ...subItem,
                            details: { ...extraDetailModalData }
                        };
                    }
                    return subItem;
                });
            }
            else {
                selectedFinalServicesClone[currentActiveCollapseKey] = [
                    ...(selectedFinalServicesClone[currentActiveCollapseKey] || []),
                    { serviceId: currentActiveCollapseKey, details: { ...extraDetailModalData } }
                ];
            }

            setSelectedFinalServices(selectedFinalServicesClone)
            setExtraDetailModal((prev) => ({
                data: { ...prev.data },
                error: { checkboxError: '', priceError: '' },
                show: false
            }))
        }
    }


    return (
        <>
            <TitleWithBackNavigation title={'Business Info'} link={'/settings'} />
            <Row justify={'space-between'} className='my-4'>
                <Col lg={10} md={24} className='mb-4'>
                    <form>
                        <Row gutter={[16, 26]}>
                            <Controller
                                name='businessName'
                                control={control}
                                defaultValue={''}
                                render={({ field, fieldState }) => {
                                    return (
                                        <Col md={12} sm={24} xs={24}>
                                            <label className='font-medium'>Business name </label>
                                            <Input className='custom--input' {...field} type='text' />
                                            {fieldState.error && <p className='text-red-500'>{fieldState.error.message}</p>}
                                        </Col>
                                    )
                                }}
                            />
                            <Controller
                                name='website'
                                control={control}
                                defaultValue={''}
                                render={({ field, fieldState }) => {
                                    return (
                                        <Col md={12} sm={24} xs={24}>
                                            <label className='font-medium'>Website </label>
                                            <Input className='custom--input' {...field} type='text' />
                                            {fieldState.error && <p className='text-red-500'>{fieldState.error.message}</p>}
                                        </Col>
                                    )
                                }}
                            />
                            <Controller
                                name='businessContact'
                                control={control}
                                defaultValue={''}
                                render={({ field, fieldState }) => {
                                    return (
                                        <Col md={12} sm={24} xs={24}>
                                            <label className='font-medium'>Business contact number </label>
                                            <Input className='custom--input' {...field} type='text' placeholder='Enter Phone Number' />
                                            {fieldState.error && <p className='text-red-500'>{fieldState.error.message}</p>}
                                        </Col>
                                    )
                                }}
                            />
                            <Controller
                                name='businessLocation'
                                control={control}
                                defaultValue={''}
                                render={({ field: { value, onChange }, fieldState }) => {
                                    return (
                                        <Col md={12} sm={24} xs={24}>
                                            <label className='font-medium'>Business Location </label>
                                            <LocationPicker
                                                value={value}
                                                isBusinessInfo={true}
                                                addressPicker={(coordinates, address) => {
                                                    onChange(address)
                                                    setCoordinates({ businessLatitude: coordinates?.lat, businessLongitude: coordinates?.lng })
                                                }}
                                                onEdit={() => { }}
                                                customFieldReset={customFieldReset.address}
                                                setCustomFieldReset={setCustomFieldReset}
                                                coordinates={coordinates}
                                            />
                                            {fieldState.error && <p className='text-red-500'>{fieldState.error.message}</p>}
                                        </Col>
                                    )
                                }}
                            />
                            <Controller
                                name='aboutBusiness'
                                control={control}
                                defaultValue={''}
                                render={({ field, fieldState }) => {
                                    return (
                                        <Col md={24} sm={24} xs={24}>
                                            <label className='font-medium'>About Business </label>
                                            <TextArea autoSize={{ minRows: 4, maxRows: 4 }} className='custom--input' rows={4} {...field} />
                                            {fieldState.error && <p className='text-red-500'>{fieldState.error.message}</p>}
                                        </Col>
                                    )
                                }}
                            />
                            <Controller
                                name='benefits'
                                control={control}
                                defaultValue={''}
                                render={({ field: { value, onChange }, fieldState }) => {
                                    return (
                                        <Col md={24} sm={24} xs={24}>
                                            <label className='font-medium'>Benefits: </label>
                                            <CustomBenefits value={value || []} onChange={(data) => {
                                                onChange(data)
                                            }} />

                                        </Col>
                                    )
                                }}
                            />
                            <Controller
                                name='workingDays'
                                control={control}
                                defaultValue={[]}
                                render={({ field: { value, onChange }, fieldState }) => {
                                    return (
                                        <Col md={24} sm={24} xs={24}>
                                            <label className='font-medium'>Working days: </label>
                                            <CustomDayPicker
                                                value={value || timePickers}
                                                onChange={(data) => {
                                                    setTimePickers(data)
                                                    if (profileData?.workingDays?.length > 0 && !isDisabled.isWorkingDaysDirty) {
                                                        setIsDisabled({ ...isDisabled, isWorkingDaysDirty: true })
                                                    }
                                                }}
                                                customFieldReset={customFieldReset.time}
                                                setCustomFieldReset={setCustomFieldReset}
                                            />
                                            {customError?.time && <p className='text-red-500'>{customError?.time}</p>}
                                        </Col>
                                    )
                                }}
                            />
                        </Row>
                        <Button
                            onClick={handleSubmit((data) => submitForm(data))}
                            loading={businessInfoMutation.isLoading}
                            htmlType='submit'
                            disabled={!isDirty && !isDisabled.isServicesDirty && !isDisabled.isWorkingDaysDirty}
                            className='w-36 h-10 mt-3 rounded-md outline-none border-none'
                            style={{ background: Colors.AppYellow, color: 'white' }}>

                            Save
                        </Button>
                    </form>

                </Col>
                <Col className='h-auto border-2 border-dotted hidden lg:inline'>
                </Col>
                <Col lg={13} md={24} sm={24} xs={24} className='p-2'>
                    <p className='font-medium'>Select Service Category</p>
                    <Collapse
                        activeKey={defaultActiveCollapseKeys}
                        items={items}
                        collapsible='icon'
                        onChange={collapseHandler}
                        expandIcon={({ isActive }) => <Checkbox onChange={checkboxHandler} checked={isActive} />}
                    />
                </Col>
            </Row>

            {
                extraDetailModal?.show &&
                <Modal
                    open={extraDetailModal?.show}
                    onCancel={() => setExtraDetailModal((prev) => ({ ...prev, show: false }))}
                    okButtonProps={false}
                    footer={false}
                    width={300}
                    centered
                >
                    <Row className='px-8 py-6 flex flex-col gap-4'>
                        <p className='w-full text-center font-semibold text-lg'>Mot Test Centers</p>
                        <Col lg={24} className='flex flex-col items-start gap-2'>
                            <div>
                                <Checkbox className='text-base'
                                    onChange={(e) => setExtraDetailModal((prev) =>
                                    ({
                                        ...prev, data: {
                                            ...prev.data,
                                            [currentActiveCollapseKey]: { ...prev?.data[currentActiveCollapseKey], cars: e.target.checked }
                                        }
                                        , error: { ...prev.error, checkboxError: '' }
                                    }))}
                                    value={extraDetailModal?.data?.[currentActiveCollapseKey]?.cars}
                                    defaultChecked={extraDetailModal?.data?.[currentActiveCollapseKey]?.cars}
                                >
                                    Cars
                                </Checkbox>
                                <Checkbox className='text-base'
                                    onChange={(e) => setExtraDetailModal((prev) =>
                                    ({
                                        ...prev, data: {
                                            ...prev.data,
                                            [currentActiveCollapseKey]: { ...prev?.data[currentActiveCollapseKey], vans: e.target.checked }
                                        }
                                        , error: { ...prev.error, checkboxError: '' }
                                    }))}
                                    value={extraDetailModal?.data?.[currentActiveCollapseKey]?.vans}
                                    defaultChecked={extraDetailModal?.data?.[currentActiveCollapseKey]?.vans}
                                >
                                    Vans
                                </Checkbox>
                            </div>
                            {extraDetailModal.error.checkboxError && <p className='text-red-500'>{extraDetailModal.error.checkboxError}</p>}
                        </Col>
                        <Col>
                            <div>
                                <label>Add Price:</label>
                                <Input
                                    style={{ boxShadow: '0px 3px 6px #0000001A' }}
                                    onChange={(e) => setExtraDetailModal((prev) =>
                                    ({
                                        ...prev, data: {
                                            ...prev.data,
                                            [currentActiveCollapseKey]: { ...prev?.data[currentActiveCollapseKey], price: e.target.value }
                                        }
                                        , error: { ...prev.error, checkboxError: '' }
                                    }))}
                                    value={extraDetailModal?.data?.[currentActiveCollapseKey]?.price}
                                />
                            </div>
                            {extraDetailModal.error.priceError && <p className='text-red-500'>{extraDetailModal.error.priceError}</p>}
                        </Col>
                        <Button onClick={motSubmitHandler} className='h-10 rounded-md outline-none border-none w-full' style={{ background: Colors.AppYellow, color: 'white' }}>
                            Save
                        </Button>
                    </Row>
                </Modal>
            }
        </>
    )
}

export default BusinessInfo